import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const SoundBarIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-soundBar"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <polygon fill="#ffffff" className={styles.white} opacity="0" points="0 0 68 0 68 34 0 34" />
        <path
          d="M52,12 L16,12 C14.3427153,12 13,13.3427153 13,15 L13,19 C13,20.6572847 14.3427153,22 16,22 L52,22 C53.6572847,22 55,20.6572847 55,19 L55,15 C55,13.3427153 53.6572847,12 52,12 Z M16,14 L52,14 C52.5527153,14 53,14.4472847 53,15 L53,19 C53,19.5527153 52.5527153,20 52,20 L16,20 C15.4472847,20 15,19.5527153 15,19 L15,15 C15,14.4472847 15.4472847,14 16,14 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M19 15C17.8957153 15 17 15.8957153 17 17 17 18.1042847 17.8957153 19 19 19 20.1042847 19 21 18.1042847 21 17 21 15.8957153 20.1042847 15 19 15ZM49 15C47.8957153 15 47 15.8957153 47 17 47 18.1042847 47.8957153 19 49 19 50.1042847 19 51 18.1042847 51 17 51 15.8957153 50.1042847 15 49 15Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon fill="#00000" className={styles.defaultColor} points="29 18 39 18 39 17 29 17" />
        <path
          d="M63.7071,25.7071 C66.2801,23.5431 68.0001,20.4071 68.0001,17.0001 C68.0001,13.5931 66.2801,10.4571 63.7071,8.2931 C62.7281,7.4691 61.3061,8.8771 62.2931,9.7071 C64.4751,11.5421 66.0001,14.0891 66.0001,17.0001 C66.0001,19.9111 64.4751,22.4571 62.2931,24.2931 C61.3071,25.1221 62.7281,26.5311 63.7071,25.7071"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M61.7071 21.7071C63.0891 20.5401 64.0001 18.8301 64.0001 17.0001 64.0001 15.1701 63.0891 13.4601 61.7071 12.2931 61.2951 11.9451 60.6971 11.8881 60.2931 12.2931 59.9351 12.6501 59.8781 13.3571 60.2931 13.7071 60.8781 14.2011 61.2731 14.6541 61.6121 15.3271 61.8611 15.8231 62.0001 16.4341 62.0001 17.0001 62.0001 17.1551 61.9901 17.3101 61.9771 17.4651 61.9691 17.5361 61.9701 17.5341 61.9801 17.4561 61.9741 17.4911 61.9691 17.5251 61.9631 17.5591 61.9461 17.6441 61.9301 17.7301 61.9101 17.8141 61.8311 18.1531 61.7431 18.4061 61.6361 18.6241 61.2961 19.3201 60.8921 19.7871 60.2931 20.2931 59.8801 20.6411 59.9341 21.3481 60.2931 21.7071 60.7021 22.1161 61.2931 22.0571 61.7071 21.7071M5.7071 24.2929C3.5241 22.4579 2.0001 19.9109 2.0001 16.9999 2.0001 14.0889 3.5241 11.5429 5.7071 9.7069 6.6931 8.8779 5.2721 7.4689 4.2931 8.2929 1.7201 10.4569.0001 13.5929.0001 16.9999.0001 20.4069 1.7201 23.5429 4.2931 25.7069 5.2721 26.5309 6.6941 25.1229 5.7071 24.2929"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
        <path
          d="M7.7071,20.2929 C7.1221,19.7989 6.7261,19.3459 6.3881,18.6729 C6.1391,18.1769 6.0001,17.5659 6.0001,16.9999 C6.0001,16.8449 6.0091,16.6899 6.0231,16.5349 C6.0311,16.4639 6.0301,16.4659 6.0201,16.5439 C6.0251,16.5089 6.0311,16.4749 6.0371,16.4409 C6.0541,16.3559 6.0701,16.2699 6.0891,16.1859 C6.1681,15.8469 6.2571,15.5939 6.3631,15.3759 C6.7041,14.6799 7.1081,14.2129 7.7071,13.7069 C8.1201,13.3589 8.0661,12.6519 7.7071,12.2929 C7.2981,11.8839 6.7071,11.9429 6.2931,12.2929 C4.9111,13.4599 4.0001,15.1699 4.0001,16.9999 C4.0001,18.8299 4.9111,20.5399 6.2931,21.7069 C6.7051,22.0549 7.3031,22.1119 7.7071,21.7069 C8.0641,21.3499 8.1221,20.6429 7.7071,20.2929"
          fill="#0050B3"
          className={styles.interactiveColor}
        />
      </g>
    </Icon>
  )
}
